import { render, staticRenderFns } from "./AccidentChildren.vue?vue&type=template&id=a8ac2fe6&scoped=true&"
import script from "./AccidentChildren.vue?vue&type=script&lang=js&"
export * from "./AccidentChildren.vue?vue&type=script&lang=js&"
import style0 from "./AccidentChildren.vue?vue&type=style&index=0&id=a8ac2fe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ac2fe6",
  null
  
)

export default component.exports